import { useState } from "react";

import { useToggleApiAccountProductRoleMutation } from "@sso/apis/apiAccountProducts";
import { Switch } from "@sso/ui/Switch";

interface ApiAccountProductToggleRoleProps {
  apiAccountId: string;
  softwareId: string;
  roleId: string;
  hasRole: boolean;
}

export const ApiAccountProductToggleRole = ({
  apiAccountId,
  softwareId,
  roleId,
  hasRole,
}: ApiAccountProductToggleRoleProps) => {
  const [checked, setChecked] = useState(hasRole);
  const [toggleRole, { isLoading }] = useToggleApiAccountProductRoleMutation();

  const handleOnChangeAccess = async (assign: boolean) => {
    setChecked(assign);
    try {
      await toggleRole({ apiAccountId, softwareId, roleId, assign }).unwrap();
    } catch (error) {
      setChecked(checked => !checked);
    }
  };

  return <Switch size="xs" loading={isLoading} value={checked} checked={checked} onChange={handleOnChangeAccess} />;
};
